import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";

const CustomEditor = ({ oldData, saveDataHandler, closeEditMode }) => {
  console.log("old", oldData);
  const editorRef = useRef(null);

  const sendDataHandler = () => {
    if (editorRef.current) {
      saveDataHandler(editorRef.current.getContent());
    }
  };

  const fileUploader = async (file) => {
    const body = new FormData();
    // backdrop
    const backDropDiv = document.querySelector(".tox .tox-dialog");
    backDropDiv.classList.add("loading");
    // disable input
    const textInputArea = document.querySelector(
      ".tox-form__controls-h-stack .tox-control-wrap input.tox-textfield"
    );
    textInputArea.disabled = true;

    body.append("image", file);
    const url = `https://api.imgbb.com/1/upload?key=347525e64775187aed4d03329dbe793a`;
    const data = await fetch(url, {
      method: "POST",
      body: body,
    })
      .then((res) => res.json())
      .then((res) => {
        // return data
        return res.data.url;
      })
      .catch((err) => {
        console.log(err);
      });
    backDropDiv.classList.remove("loading");
    textInputArea.disabled = false;
    return data;
  };
  return (
    <div className="space-y-8 mb-12">
      {/* Instructions */}
      <div>
        <Editor
          apiKey="m46q82u0uq4syti85urvj53vb7slt078d0x9jcmekj92xftb"
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue={oldData}
          // toolbar="bold italic underline code formatselect image"
          plugins="lists code image wordcount link hr table"
          init={{
            height: 500,
            menubar: false,
            toolbar:
              "undo redo styles | formatselect | " +
              "bold italic hr table link forecolor backcolor image | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat",
            file_picker_types: "image",
            file_picker_callback: (cb, value, meta) => {
              const input = document.createElement("input");
              input.setAttribute("type", "file");
              input.setAttribute("accept", "image/*");

              input.addEventListener("change", (e) => {
                const file = e.target.files[0];

                const reader = new FileReader();
                reader.addEventListener("load", async () => {
                  const uploadedUrl = await fileUploader(file);
                  cb(uploadedUrl, { title: file.name });
                });
                reader.readAsDataURL(file);
              });

              input.click();
            },
            // plugins: [
            //   "advlist autolink lists link image charmap print preview anchor",
            //   "searchreplace visualblocks code fullscreen",
            //   "insertdatetime media table paste code help wordcount",
            // ],
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      </div>

      <div className="mt-16 mx-auto flex justify-center">
        <button
          onClick={sendDataHandler}
          className="btn btnW7ide hover:bg-gray-100"
        >
          Submit
        </button>
      </div>
    </div>
  );
};
export default CustomEditor;
